module.exports = __webpack_public_path__ + "img/advertise_know2.87a40f35.png";